import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("../components/pages/Login/LoginView.vue"),
    meta: { auth: false, blockAuthUser: true },
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/chat",
    name: "chatBot",
    component: () => import("../components/pages/ChatBot/ChatBot.vue"),
    meta: { auth: false, blockAuthUser: true },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
